// extracted by mini-css-extract-plugin
export default {"fill":"InfoIcon_fill__Toil8"};